class WFFormLabelHubspot {
  constructor() {
    document.querySelectorAll('.hs-form-field input').forEach((elem) => {
      elem.addEventListener('focus', this.onFieldFocus.bind(this));
      elem.addEventListener('blur', this.onFieldBlur.bind(this));
      elem.addEventListener('change', this.onFieldChange.bind(this));
      this.fieldInit(elem);
    })
  }

  onFieldFocus(evt) {
    evt.currentTarget.closest('.hs-form-field').classList.add('active');
  }
  onFieldBlur(evt) {
    evt.currentTarget.closest('.hs-form-field').classList.remove('active');
  }
  onFieldChange(evt) {
    evt.currentTarget.closest('.hs-form-field').classList.toggle('has-value', !!evt.currentTarget.value);
  }
  fieldInit(el) {
    el.closest('.hs-form-field').classList.toggle('has-value', !!el.value);
  }
}

if(typeof hbspt !== 'undefined') {
  window.jQuery ??= (() => { });

  hbspt.forms.create({
    region: window.wf.hubspot.region,
    portalId: window.wf.hubspot.portalId,
    formId: window.wf.hubspot.formId,
    cssClass: 'd-lg-flex align-items-top justify-content-center',
    target: '#newsletter-collapse',
    onFormReady: function ($form) {
      new WFFormLabelHubspot();
    },
  });
}